import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EyeIcon } from 'lucide-react';
import { DataTable, Column } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { mockQCEntries } from '../data/mockData';
import { QCEntry } from '../types';
export function QCList() {
  const navigate = useNavigate();
  const columns: Column<QCEntry>[] = [{
    key: 'qcReferenceNo',
    label: 'QC Ref No',
    render: q => <span className="font-medium text-indigo-600" data-id="element-1809">{q.qcReferenceNo}</span>
  }, {
    key: 'product',
    label: 'Product/Item'
  }, {
    key: 'warehouse',
    label: 'Warehouse'
  }, {
    key: 'quantity',
    label: 'Quantity'
  }, {
    key: 'qcInspector',
    label: 'Inspector'
  }, {
    key: 'inspectionDate',
    label: 'Inspection Date'
  }, {
    key: 'qcStatus',
    label: 'Status',
    render: q => <StatusBadge status={q.qcStatus} data-id="element-1810" />
  }];
  return <div className="space-y-6 h-full flex flex-col" data-id="element-1811">
      <div className="flex items-center justify-between" data-id="element-1812">
        <div data-id="element-1813">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1814">Quality Control</h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1815">
            Inspect received products and manage QC actions.
          </p>
        </div>
      </div>

      <div className="flex-1" data-id="element-1816">
        <DataTable columns={columns} data={mockQCEntries} keyExtractor={item => item.id} searchPlaceholder="Search QC entries..." onRowClick={item => navigate(`/qc/${item.id}`)} actions={item => <div className="flex space-x-3 justify-end" data-id="element-1818">
              <button onClick={() => navigate(`/qc/${item.id}`)} className="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50" data-id="element-1819">
                <EyeIcon className="h-3.5 w-3.5 mr-1" data-id="element-1820" /> Action
              </button>
            </div>} data-id="element-1817" />
      </div>
    </div>;
}